import { render, staticRenderFns } from "./supper.vue?vue&type=template&id=55fbf4c4&scoped=true"
import script from "./supper.vue?vue&type=script&lang=js"
export * from "./supper.vue?vue&type=script&lang=js"
import style0 from "./supper.vue?vue&type=style&index=0&id=55fbf4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fbf4c4",
  null
  
)

export default component.exports